const ACCOUNTANT_SIGNATURE_SUFFIX = '/firmada por contador';

const ORIGINATION_STEP2_ACCOUNTANT_LABEL_DOC_IDS = new Set(['005', '010']);

function alreadyHasAccountantSignatureHint(label: string): boolean {
  const lower = label.toLowerCase();
  return lower.includes('firmad') && lower.includes('contador');
}

export function getOriginationStep2DocumentLabel(
  documentId: string,
  baseLabel: string,
  isEnabled: boolean
): string {
  if (!isEnabled || !ORIGINATION_STEP2_ACCOUNTANT_LABEL_DOC_IDS.has(documentId)) {
    return baseLabel;
  }
  if (alreadyHasAccountantSignatureHint(baseLabel)) {
    return baseLabel;
  }
  return `${baseLabel}${ACCOUNTANT_SIGNATURE_SUFFIX}`;
}
